import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssessmentService } from 'src/app/services/assessment.service';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { CourseService } from 'src/app/services/course.service';
import { jsPDF } from "jspdf";
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-assessment-view-user',
  templateUrl: './assessment-view-user.component.html',
  styleUrls: ['./assessment-view-user.component.scss'],
  providers: [DatePipe]
})
export class AssessmentViewUserComponent implements OnInit {

  adminData: any; viewUsersDetail: any; cousesData: any = []; courseForm: any = []; userID: any = '';
  course_id: any; searchText: any = ''; order: any = ''; order_by: any = 'asc'; filter_by_org: any = ''; submitted = false
  assessment_id: any; request_status: number = 0; reject_reason: string = ""; tab: any = '';myDate = new Date();currentData: any = '';
  assessmentDetails: any;currentBaseUrl: any = '';


  constructor(private modalService: NgbModal, private router: Router,
    private spinner: NgxSpinnerService, private authCours: CourseService, private route: ActivatedRoute, private contentAuthoringApi: ContentAuthoringService, private auth: AssessmentService,private datePipe: DatePipe,) { 
      if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
        this.router.navigateByUrl('/admin-login');
      }
    }

  // rejectForm = new FormGroup({
  //   txtRemark: new FormControl('',[Validators.required] ),
  // });
  // get f() { return this.rejectForm.controls; } 

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  opens(content: any, userId: any) {
    this.userID = userId;
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  viewAsmntAssignedUsers(assessment_id: any, searchText: any, order: any, order_by: any, filter_by_org: any) {
    this.spinner.show();
    this.authCours.viewAsmntAssignedUsers(assessment_id, searchText, order, order_by, filter_by_org).subscribe(
      (data) => {
        console.log(data);
        if (data.status == 200) {
          this.viewUsersDetail = data.user_assessment_list;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      (error) => {
        this.spinner.hide();
      },
    );
  }
  /****** start create duplicate course */
  duplicateCourse() {
    /*****get couse detail ****/
    this.authCours.CourseDetail(this.assessment_id).subscribe(
      data => {
        this.cousesData = data.courseData;
        this.courseForm = {
          "course_desc": data.courseData.course_desc,
          "course_id": "",
          "course_image": data.courseData.course_image,
          "course_name": data.courseData.course_name + '_copy',
          //"course_status": data.courseData.course_status,
          "course_status": 1,
          "created_by": data.courseData.db_created_dttm,
          "end_date": data.courseData.db_end_date,
          "is_active": data.courseData.is_active
        }
        this.authCours.dublicateCourse(this.courseForm).subscribe(
          (data) => {
            if (this.cousesData.courseModules.length > 0 && data.status == 201) {
              this.getModuleData(data.course_id);
            } else {
              document.getElementById('closelId')?.click();
              this.spinner.hide();
              this.router.navigate(['/courses']);
            }
          }, error => { })
      })
  }

  getModuleData(courseId: any) {
    if (this.cousesData && this.cousesData.courseModules) {
      let arr: Array<any> = this.cousesData.courseModules;
      arr.forEach((element, i) => {
        setTimeout(() => {
          let qts = element.subModules;
          for (let n = 0; n < qts.length; n++) {
            qts[n]['course_id'] = courseId;
            qts[n]['created_dttm'] = qts[n].db_created_dttm;
            qts[n]['created_by'] = qts[n].db_created_by;
          }
          element['course_id'] = courseId;
          element['created_dttm'] = element.db_created_dttm;
          element['created_by'] = element.db_created_by;
          element['subModules'] = qts;
          if (this.cousesData.courseModules.length - 1 == i) {
            this.duplicateModule(element, 1);
          } else {
            this.duplicateModule(element, 0);
          }
        }, i * 2000);
      })
      // this.spinner.hide();
    }
  }
  /*****create duplicate modules of course */
  duplicateModule(Modueldata: any, status: any) {
    this.authCours.creatModule(Modueldata, 'create').subscribe(
      data => {
        if (status == 1) {
          this.router.navigate(['/courses']);
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
      })

  }
  /****** END create duplicate course */

  // viewUsersDataBySearch(courseId: any, search_by: any) {

  //   this.authCours.ViewUsers(courseId, search_by).subscribe(
  //     (data) => {
  //       if (data.status == 200) {
  //         this.viewUsersDetail = data.courseData;
  //       }
  //     },
  //     (error) => {
  //     },
  //   );
  // }
  search(event: any) {

    this.searchText = event.target.value;
    this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
  }
  DeAssignUser(userID: any) {
    this.authCours.AssesmntDeAssignUsers(this.assessment_id, userID).subscribe(
      (data) => {
        if (data.status == 200) {
          // this.router.navigate(['/courses_view_user'], { queryParams: {courseId: this.courseId} });
          this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
          document.getElementById('closelId')?.click();
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(is_active: any) {
    this.authCours.changeIsActiveVal(this.assessment_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
        } else {
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  logout() {
    // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    //  this.assessmentDetails = JSON.parse(localStorage.getItem('assessmentDetails') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.assessment_id = queryParams['id'];
      this.assessmentDetail(this.assessment_id);
    });

    if (this.assessment_id != '' && this.assessment_id != null)
      this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
  }
  onSelect(event: any) {
    this.filter_by_org = event.target.value;
    this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
  }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order = sort.active;
      this.order_by = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order = sort.active;
      this.order_by = 'ASC';
    } else {
      this.order = '';
      this.order_by = 'DESC';
    }
    this.viewAsmntAssignedUsers(this.assessment_id, this.searchText, this.order, this.order_by, this.filter_by_org);
  };

  acceptRejectAssmnt(userID: number, assessment_id: any, request_status: any, reject_reason: any) {
    this.spinner.show();
    this.contentAuthoringApi.acceptRejectAssmnt(userID, assessment_id, request_status, reject_reason).subscribe(
      data => {
        console.log(data)
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
      }
    )
  }
  openReject(content: any, data: any) {
    console.log(data);
    this.userID = data.user_id
    // this.userID = this.adminData.userID
    // this.course_id=data.course_id
    this.assessment_id = data.assessment_id,
      this.request_status = 5,

    this.acceptRejectAssmnt(this.userID, this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' });

  }
  openAccept(content: any, data: any) {
    console.log(data);
    this.userID = data.user_id
    //this.course_id=data.course_id
    this.assessment_id = data.assessment_id,
      this.request_status = 1
    this.acceptRejectAssmnt(this.userID, this.assessment_id, this.request_status, this.reject_reason)
    this.modalService.open(content, { centered: true, size: 'sm' });

  }
  secondsToHms(d: any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h + ' hr ' + m + ' min';
  }

  assessmentDetail(id: any) {
    this.auth.assessmentDetail(id).subscribe(
      data => {
        this.assessmentDetails = data.data;
        //  localStorage.setItem('assessmentDetails', JSON.stringify(data.data))
        //console.log(data.data);
      }, error => {
        alert(error);
      }
    );
  }
  toTitleCase(str:any) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word:any) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }
  downloadAssmntCerti(data:any) {
  
    this.currentData = this.datePipe.transform(data.last_login, 'dd/MM/yyyy');
    const userName = this.toTitleCase((data?.user_name).toLowerCase());
    const assessment_name = this.assessmentDetails?.assessment_name;
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: "px",
      format: [550, 297],
    });
    var width = doc.internal.pageSize.getWidth();
    doc.setDrawColor(35, 36, 115); // draw red lines
    // TOP
    doc.setLineWidth(10);
    doc.line(0, 0, 600, 0);
    // Bottom
    doc.setLineWidth(5);
    doc.line(0, 295, 600, 295);
    //LEFT
    doc.setLineWidth(10);
    doc.line(0, 600, 0, 0);
    //RIGHT 
    doc.setLineWidth(10);
    doc.line(550, 500, 550, 0);
  
    doc.addImage(this.currentBaseUrl + 'assets/images/logo.png', 'PNG', 460, 20, 70, 15);
    doc.addImage(this.currentBaseUrl + 'assets/images/vandhanalogo.jpeg', 'JPEG',  15, 5, 80, 50);
    doc.addFont(this.currentBaseUrl + 'assets/font/itcedscr-webfont.ttf', 'edwardian_script_itcregular', 'normal');
    doc.setFont('edwardian_script_itcregular');
  
    doc.setFontSize(50);
    doc.setTextColor(67, 67, 67);
    doc.text("Certificate of Assessment Completion", width / 2, 90, { align: 'center' });
  if(userName?.length < 50){
    doc.setFontSize(25);
    doc.setTextColor(67, 67, 67);
    doc.text("This is to Certify that " +`" ` + userName + `"`+ " has successfully completed", width / 2, 123, { align: 'center' });
  if(assessment_name?.length < 50){
    doc.setLineWidth(0.5);
    // doc.line(320, 132, 210, 132);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(`" `+ assessment_name + `"`+ " on " + this.currentData + "", width / 2, 155, { align: 'center' });
  
    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 205, 60, 18);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(50, 225, 140, 225);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 125);
    doc.text("Ashish Agarwal", 63, 235);
    doc.text("Sr. Training Manager", 57, 250);
  
    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 185, 52, 70);
    doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 205, 65, 20);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(498, 225, 415, 225);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 125);
    doc.text("Diwakar Dubey", 425, 235);
    doc.text("Training Manager", 420, 250);
  }else{
    doc.setLineWidth(0.5);
    // doc.line(320, 132, 210, 132);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(`" `+ assessment_name + `"`, width / 2, 155, { align: 'center' });

    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(" on " + this.currentData + "", width / 2, 175, { align: 'center' });
  
    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(50, 245, 140, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Ashish Agarwal", 63, 255);
    doc.text("Sr. Training Manager", 57, 270);
  
    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 205, 52, 70);
    doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(498, 245, 415, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Diwakar Dubey", 425, 255);
    doc.text("Training Manager", 420, 270);
  } 
  }else{
    doc.setFontSize(25);
    doc.setTextColor(67, 67, 67);
    doc.text("This is to Certify that " +`" ` + userName + `"`, width / 2, 123, { align: 'center' });

    doc.setFontSize(25);
    doc.setTextColor(67, 67, 67);
    doc.text(" has successfully completed", width / 2, 146, { align: 'center' });
    if(assessment_name?.length < 50){
    doc.setLineWidth(0.5);
    // doc.line(320, 132, 210, 132);
    doc.setFontSize(27);
    doc.setTextColor(67, 67, 67);
    doc.text(`" `+ assessment_name + `"` + " on " + this.currentData + "", width / 2, 175, { align: 'center' });
    doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(50, 245, 140, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Ashish Agarwal", 63, 255);
    doc.text("Sr. Training Manager", 57, 270);
    doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 205, 52, 70);
    doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
    doc.setFont('normal');
    doc.setLineWidth(0.5);
    doc.line(498, 245, 415, 245);
    doc.setFontSize(12);
    doc.setTextColor(35, 66, 145);
    doc.text("Diwakar Dubey", 425, 255);
    doc.text("Training Manager", 420, 270);
    }else{
      doc.setLineWidth(0.5);
      // doc.line(310, 132, 250, 132);
      doc.setFontSize(27);
      doc.setTextColor(67, 67, 67);
      doc.text(`" `+ assessment_name + `"` , width / 2, 175, { align: 'center' });
      doc.setFontSize(27);
      doc.setTextColor(67, 67, 67);
      doc.text(" on " + this.currentData + "", width / 2, 195, { align: 'center' });
      doc.addImage(this.currentBaseUrl + 'assets/images/ashish_sign.png', 'PNG', 65, 240, 60, 18);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(50, 260, 140, 260);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 160);
      doc.text("Ashish Agarwal", 63, 270);
      doc.text("Sr. Training Manager", 57, 285);
      doc.addImage(this.currentBaseUrl + 'assets/images/bage.png', 'PNG', 260, 220, 52, 70);
      doc.addImage(this.currentBaseUrl + 'assets/images/divakarSign.png', 'PNG', 420, 240, 65, 20);
      doc.setFont('normal');
      doc.setLineWidth(0.5);
      doc.line(498, 260, 415, 260);
      doc.setFontSize(12);
      doc.setTextColor(35, 66, 160);
      doc.text("Diwakar Dubey", 425, 270);
      doc.text("Training Manager", 420, 285);
    }
  }
    doc.save(this.assessmentDetails?.assessment_name +"_certificate.pdf");
   // this.router.navigate(['/view_courses'], { queryParams: {user_id: this.userID} });
  
  }
}